import Users from '@/views/users'
import UsersList from '@/views/users/list/masters'
import InactivesList from '@/views/users/list/inactives'
import SupervisorsList from '@/views/users/list/supervisors'
import ManagersList from '@/views/users/list/managers'
import BrokersList from '@/views/users/list/brokers'
import UsersTeams from '@/views/users/teams'

import { storage } from '@/services/storage'

/**
 * Busca os nomes dos tipos de usuários para as rotas de forma dinâmica
*/
const supervisor 	= storage.get('label_supervisor') || 'Supervisor'
const manager 		= storage.get('label_manager') || 'Gerente'
const broker 		= storage.get('label_broker') || 'Corretor'

/**
 * Gera o nome dinâmico da rota.
*/
function name(name){
	return String.prototype.toLowerCase.apply(name.normalize('NFD').replaceAll(/[\u0300-\u036f]/g, '').replaceAll(/\s/g, '-'))
}

var routes = [
	{
		path: '/usuarios',
		name: 'users',
		component: Users,
		meta: {
			title: (storage.get('client_name') || 'Facilita') + ' - Usuários',
			protect: true,
		},
		children: [
			{
				path: 'lista/:new?',
				name: 'users.list',
				component: UsersList,
				props: true,
				meta: {
					title: (storage.get('client_name') || 'Facilita') + ' - Lista de Usuários',
					protect: true,
                    permissions: {
                        groups: ['broker', 'manager', 'supervisor'],
                        redirect: {name: 'errors.not.unauthorized'}
                    }
				},
			},
			{
				path: 'inativos',
				name: 'users.inactives',
				component: InactivesList,
				props: true,
				meta: {
					title: (storage.get('client_name') || 'Facilita') + ' - Lista de Usuários Bloqueados',
					protect: true,
                    permissions: {
                        groups: ['broker', 'manager', 'supervisor'],
                        redirect: {name: 'errors.not.unauthorized'}
                    }
				},
			},
			{
				path: name(supervisor),
				name: 'users.supervisors',
				component: SupervisorsList,
				props: true,
				meta: {
					title: (storage.get('client_name') || 'Facilita') + ' - Lista de ' + supervisor,
					protect: true,
                    permissions: {
                        groups: ['broker', 'manager', 'supervisor'],
                        redirect: {name: 'errors.not.unauthorized'}
                    }
				},
			},
			{
				path: name(manager),
				name: 'users.managers',
				component: ManagersList,
				props: true,
				meta: {
					title: (storage.get('client_name') || 'Facilita') + ' - Lista de ' + manager,
					protect: true,
                    permissions: {
                        groups: ['broker', 'manager'],
                        redirect: {name: 'errors.not.unauthorized'}
                    }
				},
			},
			{
				path: name(broker),
				name: 'users.brokers',
				component: BrokersList,
				props: true,
				meta: {
					title: (storage.get('client_name') || 'Facilita') + ' - Lista de ' + broker,
					protect: true,
                    permissions: {
                        groups: ['broker'],
                        redirect: {name: 'errors.not.unauthorized'}
                    }
				},
			},
            {
                path: 'grupos',
                name: 'users.teams',
                component: UsersTeams,
                props: true,
                meta: {
                    title: (storage.get('client_name') || 'Facilita') + ' - Lista de Equipes',
                    protect: true,
                    permissions: {
                        groups: ['broker', 'manager', 'supervisor'],
                        redirect: {name: 'errors.not.unauthorized'}
                    }
                },
            },
		],
	},
]

export { routes }
